module.exports = __webpack_public_path__ + "img/xml-file.49466647.svg";